var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPropaneTank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_79_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_79_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 27.5C8.625 27.5 7.44792 27.0104 6.46875 26.0313C5.48958 25.0521 5 23.875 5 22.5V12.5C5 11.3125 5.35417 10.2813 6.0625 9.40625C6.77083 8.53125 7.66667 7.94792 8.75 7.65625V5C8.75 4.3125 8.99479 3.72396 9.48438 3.23438C9.97396 2.74479 10.5625 2.5 11.25 2.5H18.75C19.4375 2.5 20.026 2.74479 20.5156 3.23438C21.0052 3.72396 21.25 4.3125 21.25 5V7.65625C22.3333 7.94792 23.2292 8.53125 23.9375 9.40625C24.6458 10.2813 25 11.3125 25 12.5V22.5C25 23.875 24.5104 25.0521 23.5312 26.0313C22.5521 27.0104 21.375 27.5 20 27.5H10ZM7.5 16.25H22.5V12.5C22.5 11.8125 22.2552 11.224 21.7656 10.7344C21.276 10.2448 20.6875 10 20 10H10C9.3125 10 8.72396 10.2448 8.23438 10.7344C7.74479 11.224 7.5 11.8125 7.5 12.5V16.25ZM10 25H20C20.6875 25 21.276 24.7552 21.7656 24.2656C22.2552 23.776 22.5 23.1875 22.5 22.5V18.75H7.5V22.5C7.5 23.1875 7.74479 23.776 8.23438 24.2656C8.72396 24.7552 9.3125 25 10 25ZM16.25 7.5H18.75V5H11.25V7.5H13.75C13.75 7.14583 13.8698 6.84896 14.1094 6.60938C14.349 6.36979 14.6458 6.25 15 6.25C15.3542 6.25 15.651 6.36979 15.8906 6.60938C16.1302 6.84896 16.25 7.14583 16.25 7.5Z",
    fill: "url(#paint0_linear_79_2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_79_2",
    x1: 15,
    y1: 2.5,
    x2: 15,
    y2: 27.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.197917,
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA5FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropaneTank);
export default __webpack_public_path__ + "static/media/propane_tank.8a1fb7db2e00db94cb35d1922f343b3f.svg";
export { ForwardRef as ReactComponent };